

@if (isLoading) {
  <div class="page-loader" [attr.data-testid]="testIdPrefix ? testIdPrefix + '-container' : null">
    <div class="loader-container">
      <img src="assets/icons/cue-logo.png" />
      @if(showText) {
        <div class="label">Loading...</div>
      }
    </div>
  </div>
}
